$(document).on("turbolinks:load", function () {
  if ($('.js-add-task-user-btn').is('*')) {
    updateMenus();

    $('body').on('change', '.js-task-user-select', function(){
      updateMenus();
    })

    $('body').on('click', '.js-add-task-user-btn', function(){
      updateMenus();
    });

    $('body').on('click', '.js-delete-field', function(){
      updateMenus();
    });    
  }
});

function updateMenus() {
  setTimeout(function(){
    if ($('.js-task-user-select').is('*')) {
      var numberOfUsers = $('select.js-task-user-select').first().find('option').length;
      var numberOfTaskUsers = $('select.js-task-user-select').length;

      if (numberOfTaskUsers == numberOfUsers) {
        $('.js-add-task-user-btn').hide();
      } else {
        $('.js-add-task-user-btn').show();
      }

      var selectedUsers = $('select.js-task-user-select').map(function(){
        return $(this).val()
      }).get();

      // iterate over menus and disable already selected users
      $('.js-task-user-select').each(function(i, select){
        $(select).find('option').each(function(ii, option){
          if ($(option).is(':selected')) {
            // don't disable selected values
            return true
          }
  
          if ($.inArray($(option).val(), selectedUsers) > -1) {
            $(option).prop('disabled', true);
          } else {
            $(option).prop('disabled', false);
          }
  
          $('.selectpicker').selectpicker("refresh");
        })
      });  
    } else {
      $('.js-add-task-user-btn').show();
    }
  }, 300);
}